import { Outlet } from 'react-router-dom';
import { ROUTES } from 'constants/routes';

import DashboardLayout from '@layouts/dashboardLayout/Dashboard.layout';
import ExternalDeliveryFilesViewPage from 'pages/external-delivery-files/external-delivery-files-view';
import ExternalDeliveryFileRegisterPage from 'pages/external-delivery-files/external-delivery-file-register';
import ExternalDeliveryFileUpdatePage from 'pages/external-delivery-files/external-delivery-file-update';
import WithAuth from 'shared/components/hocs/with-auth';

export const EXTERNAL_DELIVERY_FILES_ROUTES = {
  path: '',
  element: (
    <WithAuth>
      <Outlet />
    </WithAuth>
  ),
  children: [
    {
      path: ROUTES.EXTERNAL_DELIVERY_FILES.ROOT,
      element: (
        <DashboardLayout>
          <ExternalDeliveryFilesViewPage />
        </DashboardLayout>
      ),
    },
    {
      path: ROUTES.EXTERNAL_DELIVERY_FILES.REGISTER_FILE.path,
      element: (
        <DashboardLayout>
          <ExternalDeliveryFileRegisterPage />
        </DashboardLayout>
      ),
    },

    {
      path: `${ROUTES.EXTERNAL_DELIVERY_FILES.UPDATE_FILE.path}/:fileId`,
      element: (
        <DashboardLayout>
          <ExternalDeliveryFileUpdatePage />
        </DashboardLayout>
      ),
    },
  ],
};
